import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Alerte Redux States
import {
  GET_ALERTES,
} from "./actionType";

import {
  alerteApiResponseSuccess,
  alerteApiResponseError,
} from "./action";

//Include Both Helper File with needed methods
import {
  getAlertes as getAlertesApi,
} from "../../helpers/fakebackend_helper";

function* getAlertes() {
  try {
    const response = yield call(getAlertesApi);
    yield put(alerteApiResponseSuccess(GET_ALERTES, response));
  } catch (error) {
    yield put(alerteApiResponseError(GET_ALERTES, error));
  }
}

export function* watchGetAlertes() {
  yield takeEvery(GET_ALERTES, getAlertes);
}



function* alerteSaga() {
  yield all([
    fork(watchGetAlertes),
  ]);
}

export default alerteSaga;
